import { querySelectorAll } from '../helpers'

declare global {
  interface Window {
    Popper: any
  }
}

function isDesktop() {
  const toggleIndicator = document.querySelector('.secondary-toggle-indicator')
  return toggleIndicator && getComputedStyle(toggleIndicator).display === 'none'
}

function isTouch() {
  return !!document.querySelector('.touchevents') || navigator.maxTouchPoints
}

function isSubmenuVisible(submenu: HTMLUListElement) {
  return getComputedStyle(submenu).display !== 'none'
}

function toggleSubmenu(toggle: HTMLInputElement, state?: boolean) {
  if (typeof state !== 'undefined') {
    toggle.checked = state
  }

  querySelectorAll<HTMLInputElement>('.secondary-toggle').forEach((el) => {
    if (toggle !== el) {
      const input = el
      input.checked = false
    }
  })
}

export function initializeSubnavigation(selector: string) {
  const submenuToggles = querySelectorAll<HTMLInputElement>('.secondary-toggle')
  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('change', (e) => {
      if (!isDesktop()) {
        e.preventDefault()
        toggleSubmenu(toggle)
      }
    })
  })

  function closeAllMenus() {
    document
      .querySelectorAll<HTMLInputElement>('.secondary-toggle:checked')
      .forEach((input) => {
        input.checked = false
      })
  }

  window.addEventListener('click', (e) => {
    const target = e.target as any
    if (isDesktop() && target && !target.classList.contains('menu_item-link')) {
      closeAllMenus()
    }
  })

  querySelectorAll(selector).forEach((item) => {
    const submenu = item.querySelector<HTMLUListElement>('.secondary')
    const link = item.querySelector<HTMLAnchorElement>('.menu_item-link')
    const toggle = item.querySelector<HTMLInputElement>('.secondary-toggle')
    if (toggle) {
      item.addEventListener('mouseenter', () => {
        if (!isTouch() && isDesktop()) {
          toggleSubmenu(toggle, true)
        }
      })

      item.addEventListener('mouseleave', () => {
        if (!isTouch() && isDesktop()) {
          toggleSubmenu(toggle, false)
        }
      })

      if (link && submenu) {
        const menu = new window.Popper(link, submenu, {
          placement: 'bottom-start',
        })

        link.addEventListener('click', (e) => {
          if (isDesktop() && isTouch() && !isSubmenuVisible(submenu)) {
            e.preventDefault()
            toggleSubmenu(toggle, true)
          }
        })
      }
    }
  })
}
